<template>
  <div class="flex flex-row flex-wrap justify-center gap-10 items-center min-h-screen pb-20">
    <RouterLink v-if="showCommunities" to="/Property?type=comunidad">
      <buttonSquare :title="$t('menu.farms')">
        <img src="@/assets/img/home.svg" alt="" class="w-20">
      </buttonSquare>
    </RouterLink>
    <RouterLink v-if="showEstates" to="/Property?type=inmueble">
      <buttonSquare :title="$t('menu.estates')">
        <img src="@/assets/img/home.svg" alt="" class="w-20">
      </buttonSquare>
    </RouterLink>

    <RouterLink :to="supplySectionPath('light')">
      <buttonSquare :title="$t(supplySectionTitleKey('light'))">
        <img src="@/assets/img/luz.svg" alt="" class="w-20">
      </buttonSquare>
    </RouterLink>
    <RouterLink :to="supplySectionPath('gas')">
      <buttonSquare :title="$t(supplySectionTitleKey('gas'))">
        <img src="@/assets/img/gas.svg" alt="" class="w-20">
      </buttonSquare>
    </RouterLink>

    <template v-if="internalUser">
      <RouterLink to="/supply-bill">
        <buttonSquare :title="$t('menu.invoices')">
          <Liquidation class="w-20" />
        </buttonSquare>
      </RouterLink>
      <!-- La posible exclusividad para responsables sigue pendiente (ADS-0114). -->
      <RouterLink to="/client-admin">
        <buttonSquare :title="$t('menu.admins')">
          <Admin class="w-20" />
        </buttonSquare>
      </RouterLink>
      <RouterLink to="/users-ads">
        <buttonSquare :title="$t('menu.users_ads')">
          <UserIcon class="w-20" />
        </buttonSquare>
      </RouterLink>
    </template>
  </div>
</template>

<script setup>
import buttonSquare from '@/components/button/button-square.vue';
import Liquidation from '@/assets/svg/liquidation.vue';
import Admin from '@/assets/svg/Admin.vue';
import UserIcon from '@/assets/svg/UserIcon.vue';
import { supplySectionPath, supplySectionTitleKey } from '@/services/supplySections';
import { hasAnyRole, isAdsUser } from '@/services/userRoles';

const internalUser = isAdsUser();
const showEstates = internalUser || hasAnyRole(['vertical', 'both']);
const showCommunities = internalUser || hasAnyRole(['horizontal', 'both']) || !hasAnyRole(['vertical']);
</script>
